import angular from 'angular';

angular
  .module('cxRegistrations')
  .factory('priceService', ['$http', 'flySvc', 'appUrls', registrationService]);

function registrationService($http, flySvc, appUrls) {
  var handleRetrieve = function(response) {
    vm.translations = (response.data || []).filter(function(el) {
      return el.language !== 'de';
    });
  };
  var handleError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return error;
  };

  return {
    getPrice: function({ category, invoiceStream, user = null }) {
      return $http
        .get(appUrls.api + '/api/price/', { params: { category, invoiceStream, user } })
        .then(function({ data = null }) {
          return data;
        }, handleError);
    },
    isResourceInForfait: function({ resource, invoiceStream }) {
      return $http
        .get(appUrls.api + '/api/resource/InForfait', { params: { resource, invoiceStream } })
        .then(function({ data = null }) {
          if (data === null || typeof data === 'undefined' || data === '') return null;
          return data;
        }, handleError);
    },
  };
}
